import { render, staticRenderFns } from "./ValidationCodeInput.vue?vue&type=template&id=6a71cf77&scoped=true&"
import script from "./ValidationCodeInput.vue?vue&type=script&lang=js&"
export * from "./ValidationCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./ValidationCodeInput.vue?vue&type=style&index=0&id=6a71cf77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71cf77",
  null
  
)

export default component.exports